import { addressHandler, updateOptionsSelect2, getAddressInfo } from '../helpers/helper.js';

const initExternalTrainingForm = () => {
	if(!$('#external-training-add-edit-container').length){
		return;
	}

	const goalSelect = $('#training_goal');
	const goalOther = $('#training_goal_other');
	let productField = $('#training_content_articles');
	if(!productField.length){
		productField = $('[name="training_content_articles[]"]');
	}
	const typeSelect = $('#training_type');
	const typeOther = $('#training_type_other');
	const trainerSelect = $('#trainer_id');
	let participantsSelect = $('#participants');
	if(!participantsSelect.length){
		participantsSelect = $('[name="participants[]"]');
	}
	const participantsContainer = $('[data-external-training-participant-container]');
	const participantTemplate = $('[data-external-training-participant-template]').children().first();
	const customerSelect = $('[data-function="address-handler"]');
	const contactSelect = $('[data-id="contacts"]');
	const contactEmailField = $('[data-id="contact_person_email"]');
	const contactPhoneField = $('[data-id="contact_person_phone"]');
	const departmentSelect = $('#participant_department_id');
	const positionSelect = $('#participant_position_id');
	let previousCustomerValue = customerSelect.length ? customerSelect.val() : null;
	let skipCustomerConfirm = false;
	let pendingCustomerChange = false;
	let contactRefreshTimer = null;
	let contactsCache = [];

	const toggleGroup = (field, show) => {
		if(!field.length){
			return;
		}
		const group = field.closest('.form-group');
		if(show){
			group.removeClass('d-none');
		}else{
			group.addClass('d-none');
		}
	};

	const toggleGoalOther = () => {
		toggleGroup(goalOther, goalSelect.val() === 'other');
	};

	const toggleProductField = () => {
		toggleGroup(productField, goalSelect.val() === 'product_knowledge');
	};

	const toggleTypeOther = () => {
		toggleGroup(typeOther, typeSelect.val() === 'other');
	};

	const toggleTrainer = () => {
		toggleGroup(trainerSelect, typeSelect.val() === 'trainer');
	};

	const updateInputLink = (field, protocol, value, stripSpaces = false) => {
		if(!field.length){
			return;
		}
		const group = field.closest('.input-group');
		if(!group.length){
			return;
		}
		const link = group.find('a');
		if(!link.length){
			return;
		}
		let hrefValue = value || '';
		if(stripSpaces){
			hrefValue = hrefValue.replace(/\s+/g, '');
		}
		link.attr('href', `${protocol}${hrefValue}`);
	};

	const setContactDetails = (contact, options = {}) => {
		const { force = true } = options || {};
		const email = contact && contact.email ? contact.email : '';
		const phone = contact && contact.phone ? contact.phone : '';
		if(contactEmailField.length){
			const currentEmail = contactEmailField.val() || '';
			const nextEmail = force || currentEmail === '' ? email : currentEmail;
			contactEmailField.val(nextEmail);
			updateInputLink(contactEmailField, 'mailto:', nextEmail);
		}
		if(contactPhoneField.length){
			const currentPhone = contactPhoneField.val() || '';
			const nextPhone = force || currentPhone === '' ? phone : currentPhone;
			contactPhoneField.val(nextPhone);
			updateInputLink(contactPhoneField, 'tel:', nextPhone, true);
		}
	};

	if(contactEmailField.length){
		contactEmailField.off('input.external-training-contact-link change.external-training-contact-link').on('input.external-training-contact-link change.external-training-contact-link', function(){
			updateInputLink(contactEmailField, 'mailto:', $(this).val());
		});
	}

	if(contactPhoneField.length){
		contactPhoneField.off('input.external-training-contact-link change.external-training-contact-link').on('input.external-training-contact-link change.external-training-contact-link', function(){
			updateInputLink(contactPhoneField, 'tel:', $(this).val(), true);
		});
	}

	const findContactById = (value) => {
		if(!value || !contactsCache.length){
			return null;
		}
		const normalized = value.toString();
		return contactsCache.find((contact) => contact && contact.id !== undefined && contact.id !== null && contact.id.toString() === normalized) || null;
	};

	const getContactFilterValue = (field) => {
		if(!field.length){
			return null;
		}
		const value = field.val();
		if(value === null || value === undefined){
			return null;
		}
		const normalized = value.toString().trim();
		return /^\d+$/.test(normalized) ? normalized : null;
	};

	const getFilteredContacts = (contacts = null) => {
		const base = contacts || contactsCache || [];
		if(!base.length){
			return [];
		}
		const departmentValue = getContactFilterValue(departmentSelect);
		const positionValue = getContactFilterValue(positionSelect);
		if(!departmentValue && !positionValue){
			return base;
		}
		return base.filter((contact) => {
			if(!contact){
				return false;
			}
			if(departmentValue && contact.company_department_id && contact.company_department_id.toString() !== departmentValue.toString()){
				return false;
			}
			if(departmentValue && (contact.company_department_id === null || contact.company_department_id === undefined || contact.company_department_id === '')){
				return false;
			}
			if(positionValue && contact.company_position_id && contact.company_position_id.toString() !== positionValue.toString()){
				return false;
			}
			if(positionValue && (contact.company_position_id === null || contact.company_position_id === undefined || contact.company_position_id === '')){
				return false;
			}
			return true;
		});
	};

	const hasActiveParticipantFilters = () => {
		return getContactFilterValue(departmentSelect) !== null || getContactFilterValue(positionSelect) !== null;
	};

	const initTrainingEditor = () => {
		if(!window.ClassicEditor){
			return;
		}
		document.querySelectorAll('.ckeditor-training').forEach((element) => {
			if(element.dataset.ckeditorInitialized){
				return;
			}
			element.dataset.ckeditorInitialized = 'true';
			ClassicEditor.create(element, {
				toolbar: ['heading', 'bold', 'italic', 'bulletedList', 'numberedList', 'link', 'insertTable'],
				table: {
					contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
				},
				removePlugins: [
					'Image',
					'ImageCaption',
					'ImageStyle',
					'ImageToolbar',
					'ImageUpload',
					'MediaEmbed',
					'CKFinder',
					'CKFinderUploadAdapter',
					'EasyImage',
					'BlockQuote'
				],
				placeholder: ''
			}).then((editor) => {
				const editable = editor.ui && editor.ui.view && editor.ui.view.editable ? editor.ui.view.editable.element : null;
				if(editable){
					editable.style.minHeight = '120px';
				}
			});
		});
	};

	const parseContactValues = () => {
		const raw = participantsSelect.data('contact-values') || participantsSelect.attr('data-contact-values');
		if(!raw){
			return [];
		}
		if(Array.isArray(raw)){
			return raw;
		}
		try{
			return JSON.parse(raw);
		}catch(error){
			return [];
		}
	};

	const getOptionValues = () => participantsSelect.find('option').map((index, option) => option.value).get();

	const addParticipantRow = (value = '') => {
		if(!participantTemplate.length || !participantsContainer.length){
			return;
		}
		const row = participantTemplate.clone();
		row.find('[data-external-training-participant-input]').val(value);
		participantsContainer.append(row);
	};

	const initializeExtraParticipants = () => {
		if(!participantsSelect.length || !participantsContainer.length){
			return;
		}
		const selected = participantsSelect.val() || [];
		const selectedValues = Array.isArray(selected) ? selected.slice() : [selected];
		const contactValues = parseContactValues();
		const baseValues = contactValues.length ? contactValues : getOptionValues();
		const optionValues = new Set(baseValues.map((value) => value.toString()));
		const keptValues = [];
		const extraValues = [];
		selectedValues.forEach((value) => {
			if(value === null || value === undefined){
				return;
			}
			const normalized = value.toString();
			if(normalized.trim() === ''){
				return;
			}
			if(optionValues.has(normalized)){
				keptValues.push(normalized);
			}else{
				extraValues.push(normalized);
			}
		});

		if(extraValues.length){
			extraValues.forEach((value) => {
				addParticipantRow(value);
				participantsSelect.find('option').filter((index, option) => option.value === value).remove();
			});
			participantsSelect.val(keptValues).trigger('change.select2');
		}
	};

	const normalizeContactNames = (contacts = []) => {
		if(!Array.isArray(contacts)){
			return [];
		}
		return contacts
			.map((contact) => {
				if(!contact){
					return null;
				}
				if(typeof contact === 'string'){
					return contact;
				}
				if(contact.full_name){
					return contact.full_name;
				}
				if(contact.text){
					return contact.text;
				}
				return null;
			})
			.filter((name) => name && name.toString().trim() !== '');
	};

	const getContactNamesFromSelect = () => {
		if(!contactSelect.length){
			return [];
		}
		return contactSelect.find('option')
			.map((index, option) => {
				if(!option.value){
					return null;
				}
				return option.text;
			})
			.get()
			.filter((name) => name && name.toString().trim() !== '');
	};

	const updateParticipantsFromContacts = (contacts = [], options = {}) => {
		if(!participantsSelect.length){
			return;
		}

		const {
			selectAll = false,
			selectedValues = null,
			resetExtras = true,
			allowFallbackToContactSelect = true,
		} = options || {};
		participantsSelect.prop('disabled', false).removeAttr('disabled');

		let contactNames = normalizeContactNames(contacts);
		if(!contactNames.length && allowFallbackToContactSelect){
			contactNames = getContactNamesFromSelect();
		}
		participantsSelect.data('contact-values', contactNames);
		const selectedList = selectedValues && selectedValues.length
			? selectedValues.map((value) => value.toString()).filter((value) => value.trim() !== '')
			: [];
		const contactNameSet = new Set(contactNames.map((value) => value.toString()));
		const manualSelectedValues = selectedList.filter((value) => !contactNameSet.has(value));
		const selectOptions = contactNames.map((name) => ({ id: name, text: name }));
		manualSelectedValues.forEach((value) => {
			selectOptions.push({ id: value, text: value });
		});
		if(participantsSelect.hasClass('select2-hidden-accessible')){
			participantsSelect.select2('destroy');
		}
		updateOptionsSelect2(participantsSelect, selectOptions);
		participantsSelect.prop('disabled', false).removeAttr('disabled');
		participantsSelect.next('.select2-container').removeClass('select2-container--disabled');
		participantsSelect.next('.select2-container').find('.select2-selection').attr('aria-disabled', 'false');
		let nextSelection = [];
		if(selectAll && contactNames.length){
			nextSelection = contactNames.concat(manualSelectedValues);
		} else if(selectedList.length){
			nextSelection = selectedList.filter((value) => contactNameSet.has(value) || manualSelectedValues.includes(value));
		}
		participantsSelect.val(nextSelection.length ? nextSelection : null).trigger('change');
		if(resetExtras && participantsContainer.length){
			participantsContainer.empty();
		}
	};

	const refreshParticipantsFromContactSelect = (selectAll = false) => {
		const filteredContacts = getFilteredContacts();
		if(filteredContacts.length){
			updateParticipantsFromContacts(filteredContacts, {
				selectAll,
				resetExtras: true,
				allowFallbackToContactSelect: false,
			});
			return;
		}
		if(hasActiveParticipantFilters()){
			updateParticipantsFromContacts([], {
				selectAll: false,
				resetExtras: true,
				allowFallbackToContactSelect: false,
			});
			return;
		}
		updateParticipantsFromContacts(getContactNamesFromSelect(), {
			selectAll,
			resetExtras: true,
			allowFallbackToContactSelect: false,
		});
	};

	const scheduleContactRefresh = () => {
		if(contactRefreshTimer){
			clearTimeout(contactRefreshTimer);
		}
		contactRefreshTimer = setTimeout(() => {
			if(!pendingCustomerChange){
				return;
			}
			pendingCustomerChange = false;
			refreshParticipantsFromContactSelect(false);
		}, 500);
	};

	const hasSelectedParticipants = () => {
		const selected = participantsSelect.length ? (participantsSelect.val() || []) : [];
		const selectedValues = Array.isArray(selected) ? selected : [selected];
		const hasSelected = selectedValues.some((value) => value !== null && value !== undefined && value.toString().trim() !== '');
		if(hasSelected){
			return true;
		}
		if(!participantsContainer.length){
			return false;
		}
		const extraInputs = participantsContainer.find('[data-external-training-participant-input]');
		let extraFilled = false;
		extraInputs.each(function(){
			if($(this).val().toString().trim() !== ''){
				extraFilled = true;
				return false;
			}
		});
		return extraFilled;
	};

	const clearParticipants = () => {
		if(participantsSelect.length){
			participantsSelect.val(null).trigger('change');
		}
		if(participantsContainer.length){
			participantsContainer.empty();
		}
	};

	const getParticipantWarning = () => {
		if(!customerSelect.length){
			return null;
		}
		return customerSelect.data('participants-warning')
			|| customerSelect.attr('data-participants-warning')
			|| 'Changing the customer will remove selected participants. Continue?';
	};

	if(goalSelect.length){
		goalSelect.unbind('change.external-training-goal').bind('change.external-training-goal', () => {
			toggleGoalOther();
			toggleProductField();
		});
	}
	if(typeSelect.length){
		typeSelect.unbind('change.external-training-type').bind('change.external-training-type', () => {
			toggleTypeOther();
			toggleTrainer();
		});
	}

	if(customerSelect.length){
		customerSelect.off('change.external-training-confirm').on('change.external-training-confirm', function(event){
            if(skipCustomerConfirm){
				skipCustomerConfirm = false;
				return;
			}
			const nextValue = $(this).val();
			if(nextValue === previousCustomerValue){
				return;
			}

			if(hasSelectedParticipants()){
				const warning = getParticipantWarning();
				if(!window.confirm(warning)){
					skipCustomerConfirm = true;
					$(this).val(previousCustomerValue).trigger('change.select2');
					event.stopImmediatePropagation();
					return;
				}
			}
			previousCustomerValue = nextValue;
			clearParticipants();
			if(contactSelect.length){
				contactSelect.val(null).trigger('change.select2');
			}
			contactsCache = [];
			setContactDetails(null);
			pendingCustomerChange = true;
			scheduleContactRefresh();
		});
	}

	$('[data-function="add-external-participant"]').unbind('click.add-external-participant').bind('click.add-external-participant', () => {
		addParticipantRow();
	});

	participantsContainer.on('click', '[data-function="remove-external-participant"]', function(){
		$(this).closest('[data-external-training-participant-row]').remove();
	});

	toggleGoalOther();
	toggleProductField();
	toggleTypeOther();
	toggleTrainer();
	initializeExtraParticipants();
	initTrainingEditor();

	if(contactSelect.length){
		const refreshContactDetailsFromSelection = () => {
			if(!contactsCache.length){
				return;
			}
			const selectedContact = findContactById(contactSelect.val());
			setContactDetails(selectedContact);
		};

		const observer = new MutationObserver(() => {
			if(!pendingCustomerChange){
				refreshContactDetailsFromSelection();
				return;
			}
			pendingCustomerChange = false;
			refreshParticipantsFromContactSelect(false);
			refreshContactDetailsFromSelection();
		});
		observer.observe(contactSelect[0], { childList: true });
		contactSelect.off('change.external-training-contacts').on('change.external-training-contacts', () => {
			if(!pendingCustomerChange){
				refreshContactDetailsFromSelection();
				return;
			}
			pendingCustomerChange = false;
			refreshParticipantsFromContactSelect(false);
			refreshContactDetailsFromSelection();
		});
	}

	if(departmentSelect.length || positionSelect.length){
		const handleParticipantFiltersChange = () => {
			const selected = participantsSelect.length ? (participantsSelect.val() || []) : [];
			const selectedValues = Array.isArray(selected) ? selected : [selected];
			const filtersActive = hasActiveParticipantFilters();
			const filteredContacts = getFilteredContacts();
			if(filteredContacts.length){
				updateParticipantsFromContacts(filteredContacts, {
					selectAll: filtersActive,
					selectedValues,
					resetExtras: false,
					allowFallbackToContactSelect: false,
				});
				return;
			}
			if(filtersActive){
				updateParticipantsFromContacts([], {
					resetExtras: false,
					allowFallbackToContactSelect: false,
				});
				return;
			}
			updateParticipantsFromContacts(getContactNamesFromSelect(), {
				selectedValues,
				resetExtras: false,
				allowFallbackToContactSelect: false,
			});
		};
		departmentSelect.off('change.external-training-filter').on('change.external-training-filter', handleParticipantFiltersChange);
		positionSelect.off('change.external-training-filter').on('change.external-training-filter', handleParticipantFiltersChange);
	}

	addressHandler((data) => {
		if(!pendingCustomerChange){
			return;
		}
		pendingCustomerChange = false;
		if(!data){
			contactsCache = [];
			setContactDetails(null);
			updateParticipantsFromContacts([], {
				selectAll: false,
				resetExtras: true,
				allowFallbackToContactSelect: false,
			});
			return;
		}
		if(data && Array.isArray(data.contacts)){
			contactsCache = data.contacts;
			setContactDetails(findContactById(contactSelect.val()));
			updateParticipantsFromContacts(getFilteredContacts(data.contacts), {
				selectAll: hasActiveParticipantFilters(),
				resetExtras: true,
				allowFallbackToContactSelect: false,
			});
			return;
		}
		if(window.pageVar && window.pageVar.address && Array.isArray(window.pageVar.address.contacts)){
			contactsCache = window.pageVar.address.contacts;
			setContactDetails(findContactById(contactSelect.val()));
			updateParticipantsFromContacts(getFilteredContacts(window.pageVar.address.contacts), {
				selectAll: hasActiveParticipantFilters(),
				resetExtras: true,
				allowFallbackToContactSelect: false,
			});
			return;
		}
		refreshParticipantsFromContactSelect(false);
	});

	if(customerSelect.length && !contactsCache.length && customerSelect.val()){
		const customerValue = customerSelect.val();
		if(/^\d+$/.test(customerValue.toString())){
			getAddressInfo(customerValue, (data) => {
				if(!data || !Array.isArray(data.contacts)){
					return;
				}
				contactsCache = data.contacts;
				const selected = participantsSelect.length ? (participantsSelect.val() || []) : [];
				const selectedValues = Array.isArray(selected) ? selected : [selected];
				const filtersActive = hasActiveParticipantFilters();
				updateParticipantsFromContacts(getFilteredContacts(data.contacts), {
					selectAll: filtersActive,
					selectedValues,
					resetExtras: false,
					allowFallbackToContactSelect: false,
				});
				setContactDetails(findContactById(contactSelect.val()), { force: false });
			});
		}
	}

	if(customerSelect.length){
		customerSelect.off('change.external-training-participants-reset');
	}

};

export default initExternalTrainingForm;
